export const WORK_SCHEMAS = [
    "indexation",
    "identificationWorkSchema",
    "descriptionWorkSchema",
    "eventWorkSchema",
    "linkWorkSchema",
    "historicWorkSchema",
    "canCreateVariant",
]

export const MUSEUM_WORK_SCHEMAS = WORK_SCHEMAS.concat([
    "descriptionMuseumWorkSchema",
    "historicMuseumWorkSchema",
])

export interface Work {
    id: string
    type: string
    entityType?: string
    descriptionMuseumWorkSchema?: any
    descriptionWorkSchema?: any
}